// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"fd42918f","295":"cd6f022c","591":"74f22c3f","615":"be41ca15","619":"0e9d651e","731":"24ecc3ff","777":"f55536c8","862":"3b9e5db0"}[chunkId] + ".chunk.js";
};